import { lazy } from "react";

/**
 * Petrovic's own four screens, as four chunks fetched only by somebody who goes to one.
 *
 * They were part of the single 1.0 MB bundle every client downloaded before the sign-in form could
 * render. `AdminOperationsRoute` alone is over four thousand lines, and all four refuse a session
 * that is not a platform admin, in the view and again in every gateway behind them, so a client was
 * paying for code that exists to turn them away.
 *
 * They sit in their own module rather than in `routeTable.tsx` so that the table exports a table and
 * this exports components. A file that mixes the two breaks fast refresh in development, which is a
 * small thing, but the split costs nothing and the eslint rule is right about it.
 *
 * This is the only code splitting in the client. Anything wider is separate work with its own
 * measurements.
 */

export const AdminRequestsRoute = lazy(() =>
  import("./AdminRequestsRoute").then((module) => ({ default: module.AdminRequestsRoute }))
);

export const AdminOperationsRoute = lazy(() =>
  import("./AdminOperationsRoute").then((module) => ({ default: module.AdminOperationsRoute }))
);

export const AdminClientsRoute = lazy(() =>
  import("./AdminClientsRoute").then((module) => ({ default: module.AdminClientsRoute }))
);

export const AdminInboxRoute = lazy(() =>
  import("./AdminInboxRoute").then((module) => ({ default: module.AdminInboxRoute }))
);

export const AdminSettingsRoute = lazy(() =>
  import("./AdminSettingsRoute").then((module) => ({ default: module.AdminSettingsRoute }))
);

export const AdminNotificationsRoute = lazy(() =>
  import("./AdminSettingsRoute").then((module) => ({ default: module.AdminNotificationsRoute }))
);

// "Visa som kund", build round 41 (2026-10-11): the frame only; the screens are the client's own.
export const AsClientRoute = lazy(() =>
  import("./asClient/AsClientRoute").then((module) => ({ default: module.AsClientRoute }))
);

export const AdminEvidenceRoute = lazy(() =>
  import("./AdminEvidenceRoute").then((module) => ({ default: module.AdminEvidenceRoute }))
);
